import intl from "react-intl-universal";
import { DATA_FORMAT_TYPES, getDataFormat } from "utils/format-date";
import { DescriptionText, HighlightBox, SectionContent } from "../../styled";

interface DeliveryDateDefinitionProps {
  originalSuggestedPickupDate?: string;
  originalSuggestedDeliveryDate?: string;
  transitTime?: string;
  description?: string;
}

const DeliveryDateDefinition = (props: DeliveryDateDefinitionProps) => {
  const { originalSuggestedPickupDate, originalSuggestedDeliveryDate, transitTime, description } =
    props;

  return (
    <SectionContent>
      <DescriptionText $fontSize="0.75rem" $fontWeight={700}>
        {intl.get("stocks.suggestionContext.deliveryDateDefinition.title")}
      </DescriptionText>

      <div>
        <DescriptionText $fontWeight={700}>
          {intl.get("stocks.suggestionContext.deliveryDateDefinition.pickupDateLabel")}
        </DescriptionText>
        <DescriptionText>
          {getDataFormat(originalSuggestedPickupDate, DATA_FORMAT_TYPES.WITH_YEAR)}
        </DescriptionText>
      </div>

      <div>
        <DescriptionText $fontWeight={700}>
          {intl.get("stocks.suggestionContext.deliveryDateDefinition.transitLabel")}
        </DescriptionText>
        <DescriptionText>{`${transitTime} ${intl.get("stocks.suggestionContext.daysUnit")}`}</DescriptionText>
      </div>

      <HighlightBox>
        <DescriptionText $fontWeight={700}>
          {intl.get("stocks.suggestionContext.deliveryDateDefinition.expectedDeliveryLabel")}
        </DescriptionText>

        <DescriptionText>
          {getDataFormat(originalSuggestedDeliveryDate, DATA_FORMAT_TYPES.WITH_YEAR)}
        </DescriptionText>
      </HighlightBox>

      <DescriptionText>{description}</DescriptionText>
    </SectionContent>
  );
};

export default DeliveryDateDefinition;
